import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import CustomerNav from './components/CustomerNav';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Profile from './pages/Profile';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import AdminDashboard from './pages/admin/Dashboard';
import AdminProducts from './pages/admin/Products';
import AdminOrders from './pages/admin/Orders';
import AdminOrderDetail from './pages/admin/OrderDetail';
import CreateOrder from './pages/admin/CreateOrder';
import AdminProductEdit from './pages/admin/ProductEdit';
import AdminSettings from './pages/admin/Settings';
import UserManagement from './pages/admin/UserManagement';
import AdminStats from './pages/admin/Stats';
import AdminInventory from './pages/admin/Inventory';
import PayOrder from './pages/PayOrder';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <div className="app">
      <Header />
      <CustomerNav />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/pay/:id" element={<PayOrder />} />

          {/* Protected Routes */}
          <Route path="/checkout" element={
            <ProtectedRoute>
              <Checkout />
            </ProtectedRoute>
          } />
          <Route path="/profile" element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          } />
          <Route path="/orders" element={
            <ProtectedRoute>
              <Orders />
            </ProtectedRoute>
          } />
          <Route path="/orders/:id" element={
            <ProtectedRoute>
              <OrderDetail />
            </ProtectedRoute>
          } />

          {/* Admin Routes */}
          <Route path="/dashboard4" element={
            <ProtectedRoute adminOnly>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/dashboard4/products" element={
            <ProtectedRoute adminOnly>
              <AdminProducts />
            </ProtectedRoute>
          } />
          <Route path="/dashboard4/products/:id/edit" element={
            <ProtectedRoute adminOnly>
              <AdminProductEdit />
            </ProtectedRoute>
          } />
          <Route path="/dashboard4/orders" element={
            <ProtectedRoute adminOnly>
              <AdminOrders />
            </ProtectedRoute>
          } />
          <Route path="/dashboard4/orders/:id" element={
            <ProtectedRoute adminOnly>
              <AdminOrderDetail />
            </ProtectedRoute>
          } />
          <Route path="/dashboard4/create-order" element={
            <ProtectedRoute adminOnly>
              <CreateOrder />
            </ProtectedRoute>
          } />
          <Route path="/dashboard4/settings" element={
            <ProtectedRoute adminOnly>
              <AdminSettings />
            </ProtectedRoute>
          } />
          <Route path="/dashboard4/stats" element={
            <ProtectedRoute adminOnly>
              <AdminStats />
            </ProtectedRoute>
          } />
          <Route path="/dashboard4/inventory" element={
            <ProtectedRoute adminOnly>
              <AdminInventory />
            </ProtectedRoute>
          } />
          <Route path="/dashboard4/users" element={
            <ProtectedRoute adminOnly>
              <UserManagement />
            </ProtectedRoute>
          } />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
